





import Vue from 'vue'
import StripeInvoice from '@/types/StripeInvoice.interface'
import { mapGetters } from 'vuex'
import IListTile from '@/types/components/IListTile.interface'
import IListIcon, { IListIconType } from '@/types/components/IListIcon.interface'
export default Vue.extend({
    data() {
        return {
            paymentHistoryPlaceholder: {
                content: 'No Invoices to Display',
                img: 'noTasks'
            }
        }
    },
    mounted() {
        //  Get our stripe invoices
        this.$store.dispatch('stripeInvoicesPaginate', {
            page: 1,
            tenant_id: this.tenant.id
        })
    },
    computed: {
        ...mapGetters({
            invoices: 'stripeInvoices',
            isApp: 'isApp',
            memberships: 'tenantMemberships',
            tenant: 'tenant'
        })
    },
    methods: {
        goToInvoiceConfirm(invoice: StripeInvoice): void {
            this.$store.dispatch('dialogOpen', {
                type: 'CONFIRM',
                icon: 'mdi-receipt',
                title: 'Download Invoice Receipt',
                text: `Would you like to download a PDF of your receipt for this invoice?`,
                callback: (result: boolean): void => this.goToInvoice(result, invoice)
            })
        },
        goToInvoice(dialog_result: boolean, invoice: StripeInvoice): void {
            //  If the user answered 'NO' in the dialog, do nothing
            if (!dialog_result) return

            //  Else, pop a new browser tab and navigate to the invoice's pdf link
            window.open(invoice.invoice_pdf, this.isApp ? '_system' : '_blank')
        },
        invoiceColor(invoice: StripeInvoice): string {
            //  If the invoice is already paid, we style it with grey
            if (invoice.status === 'paid') return 'grey'

            //  Else, return primary
            return 'primary'
        },
        invoiceDate(invoice: StripeInvoice): string {
            //  Create a container to hold our due data
            let date = null

            //  Check if the invoice is flagged 'charge_automatically' (Due date is not set on auto charge invoices)
            const isChargeAuto = invoice.collection_method === 'charge_automatically'

            //  If the invoice is charged automatically, we use the 'finalized' date instead of 'due-date'
            if (isChargeAuto) date = invoice.status_transitions.finalized_at
            //  Else, we use the invoice 'due_date'
            else date = invoice.due_date

            //  Return the formatted due date
            if (date) return `Due: ${this.$options.filters.timestamp(date)}`
        },
        invoiceIcon(invoice: StripeInvoice): IListIcon {
            //  We always use the same icon
            const icon = 'mdi-receipt'

            //  The color depends on the invoice status
            const color = this.invoiceColor(invoice)

            //  Create our list icon
            const listIcon: IListIcon = {
                type: IListIconType.icon,
                content: icon,
                color: color
            }

            //  Return our list icon
            return listIcon
        },
        invoiceLine1(invoice: StripeInvoice): string {
            return `${invoice.lines.data[0].description} ${
                this.tenant.subdomain ? this.tenant.subdomain : this.tenant.company_name
            }`
        },
        paymentHistoryTile(): IListTile {
            return {
                leftFooter: 'Invoice',
                leftIcon: (invoice: StripeInvoice) => this.invoiceIcon(invoice),
                line1: (invoice: StripeInvoice) => this.invoiceLine1(invoice),
                line2: (invoice: StripeInvoice) => this.invoiceDate(invoice),
                line3: (invoice: StripeInvoice) =>
                    `Amount: ${this.$options.filters.stripePrice(invoice.amount_due)}`,
                line4: (invoice: StripeInvoice) =>
                    `Invoice Status: ${invoice.status.toProperCase()}`,
                callback: (invoice: StripeInvoice) => this.goToInvoiceConfirm(invoice)
            }
        },
        subTenant(invoice: StripeInvoice): string {
            let subId = invoice.subscription
            let mem = this.memberships.find(
                (x) => x.tenant.stripe_subscription_id === subId
            )
            if (mem) return mem.tenant.company_name || mem.tenant.subdomain
            return ''
        }
    }
})
